module.exports = __webpack_public_path__ + "staticmedia/media/Roboto-Regular.230e0e1a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fonts/Roboto-Regular.ttf
// module id = 112
// module chunks = 0